export const PERMISSIONS = {
  HOME: 'CAN_VIEW_HOME',

  // Procesos de Selección
  PROCESO_SELECCION_VER: 'CAN_VIEW_PROCESO_SELECCION',
  PROCESO_SELECCION_CREAR: 'CAN_CREATE_PROCESO_SELECCION',
  PROCESO_SELECCION_EDITAR: 'CAN_UPDATE_PROCESO_SELECCION',
  PROCESO_SELECCION_VER_FILTRO: 'CAN_VIEW_FILTER_BUTTON_PROCESOS_SELECCION',
  PROCESO_SELECCION_CANCELAR: 'CAN_CANCELAR_PROCESO_SELECCION',
  PROCESO_SELECCION_ASIGNAR_RESPONSABLE: 'CAN_ASIGNAR_RESPONSABLE',
  PROCESO_SELECCION_ASIGNAR_URGENCIA: 'CAN_ASIGNAR_ASIGNAR_URGENCIA',
  PROCESO_SELECCION_VER_CANDIDATOS: 'CAN_VIEW_CANDIDATO',

  // Filtros de Procesos de Selección
  FILTRO_NOMBRE_SOLICITANTE: 'CAN_FILTER_BY_NOMBRE_SOLICITANTE',
  FILTRO_URGENCIA: 'CAN_FILTER_BY_URGENCIA',
  FILTRO_ZONA: 'CAN_FILTER_BY_ZONA',
  FILTRO_OFICINA: 'CAN_FILTER_BY_OFICINA',
  FILTRO_GERENCIA: 'CAN_FILTER_BY_GERENCIA',

  // Solicitudes de Candidato
  SOLICITUD_CANDIDATO_VER: 'CAN_VIEW_SOLICITUD_CANDIDATO',
  SOLICITUD_CANDIDATO_CREAR: 'CAN_CREATE_SOLICITUD_CANDIDATO',
  SOLICITUD_CANDIDATO_EDITAR: 'CAN_UPDATE_SOLICITUD_CANDIDATO',

  // Ingreso de Candidato
  INGRESO_CANDIDATO_VER: 'CAN_VIEW_INGRESO_CANDIDATO',
  INGRESO_CANDIDATO_CREAR: 'CAN_CREATE_INGRESO_CANDIDATO',
  INGRESO_CANDIDATO_EDITAR: 'CAN_UPDATE_INGRESO_CANDIDATO',

  // Colaborador
  COLABORADOR_VER: 'CAN_VIEW_COLABORADOR',
  COLABORADOR_CREAR: 'CAN_CREATE_COLABORADOR',
  COLABORADOR_EDITAR: 'CAN_UPDATE_COLABORADOR',

  // Usuarios (Administración)
  USUARIOS_VER: 'CAN_VIEW_USERS',
  USUARIOS_CREAR: 'CAN_CREATE_USERS',
  USUARIOS_EDITAR: 'CAN_UPDATE_USERS',

  // Bitácora
  BITACORA_VER: 'CAN_VIEW_BITACORA',
  BITACORA_CREAR: 'CAN_CREATE_BITACORA',
  BITACORA_EDITAR: 'CAN_UPDATE_BITACORA',

  // Datos Generales
  DATOS_GENERALES_VER: 'CAN_VIEW_DATOS_GENERALES',
  DATOS_GENERALES_EDITAR: 'CAN_UPDATE_DATOS_GENERALES',

  // Correo Notificación
  CORREO_NOTIFICACION_ENVIAR: 'CAN_SEND_CORREO_NOTIFICACION',

  // Formulario Solicitud Selección
  FORMULARIO_SOLICITUD_SELECCION_VER: 'CAN_VIEW_FORMULARIO_SOLICITUD_SELECCION',
  FORMULARIO_SOLICITUD_SELECCION_CREAR: 'CAN_CREATE_FORMULARIO_SOLICITUD_SELECCION',
  FORMULARIO_SOLICITUD_SELECCION_EDITAR: 'CAN_UPDATE_FORMULARIO_SOLICITUD_SELECCION',

  // Formulario Solicitud Ingreso
  FORMULARIO_SOLICITUD_INGRESO_VER: 'CAN_VIEW_FORMULARIO_SOLICITUD_INGRESO',
  FORMULARIO_SOLICITUD_INGRESO_CREAR: 'CAN_CREATE_FORMULARIO_SOLICITUD_INGRESO',
  FORMULARIO_SOLICITUD_INGRESO_EDITAR: 'CAN_UPDATE_FORMULARIO_SOLICITUD_INGRESO',
  FORMULARIO_SOLICITUD_INGRESO_VALIDAR: 'CAN_VALIDATE_FORMULARIO_SOLICITUD_INGRESO',

  // Grillas
  GRILLA_PROCESOS_INGRESO_VER: 'CAN_VIEW_GRILLA_PROCESOS_INGRESO',
  GRILLA_PROCESOS_SELECCION_VER: 'CAN_VIEW_GRILLA_PROCESOS_SELECCION',

  // Carta Oferta
  SOLICITUD_INGRESO_CARTA_OFERTA_VER: 'CAN_VIEW_CARTA_OFERTA',
  SOLICITUD_INGRESO_CARTA_OFERTA_CREAR: 'CAN_CREATE_CARTA_OFERTA',
  SOLICITUD_INGRESO_CARTA_OFERTA_EDITAR: 'CAN_UPDATE_CARTA_OFERTA',
  SOLICITUD_INGRESO_CARTA_OFERTA_ENVIAR: 'CAN_SEND_CARTA_OFERTA',
} as const;

/**
 * Tipo union de todos los strings de permiso válidos.
 * Útil para tipar parámetros que esperan un permiso.
 */
export type Permission = (typeof PERMISSIONS)[keyof typeof PERMISSIONS];
